import { render } from "./Melati.vue?vue&type=template&id=2bdf0fff&scoped=true&ts=true"
import script from "./Melati.vue?vue&type=script&lang=ts"
export * from "./Melati.vue?vue&type=script&lang=ts"

import "./Melati.vue?vue&type=style&index=0&id=2bdf0fff&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdf0fff"]])

export default __exports__